import React, { PropsWithChildren } from 'react';

import * as css from './PageContent.css';

export const PageContent = ({ children }: PropsWithChildren) => {
  return (
    <main className={css.main} data-qa="main-content">
      {children}
    </main>
  );
};

export default PageContent;
